// import React from "react";
import React, { useEffect, useState, useContext } from "react";
import * as publicApi from "../../../service/publicApi";
import PageHeader from "../../pageheader/PageHeader";
import Breadcrumb from "../breacrumb/breadcrumb";
import HeadBar from "../headBar/HeadBar";
import Footer from "../footer/Footer";
import { CurrentUserContext } from "../../../App";
import { RedirectCode400 } from "../../RedirectCode400";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router";
import logo__home from "../../../asset/image/logo.svg";
import Pagination from "../pagination/pagination";
import style from "./Content.module.css";

function Content({ disabledMenu, slug, role }) {
  let params = useParams();
  const navigate = useNavigate();

  const { setIsMessage } = useContext(CurrentUserContext);

  const [titleName, setTitleName] = useState();
  const [content, setContent] = useState([]);
  const [page, setPage] = useState(1);
  const [maxPage, setMaxPage] = useState(0);
  const [amount, setAmount] = useState(0);

  const pathItems = [
    { name: "หน้าหลัก", url: `${role ?? ""}/` },
    { name: titleName, url: `${role ?? ""}/news` },
  ];

  useEffect(() => {
    setPage(1);
  }, [params]);

  useEffect(() => {
    window.scrollTo(0, 0);
    if (params.slug === "news" || slug === "news") {
      setTitleName("ประชาสัมพันธ์");
      getContent(page, params.slug);
    } else if (params.slug === "article") {
      setTitleName("บทความ");
      getContent(page, params.slug);
    } else if (params.slug === "announcement") {
      setTitleName("ประกาศ");
      getContent(page, params.slug);
    } else {
      navigate(RedirectCode400());
    }
  }, [page, params]);

  const getContent = async (newPage, type) => {
    let body = {
      type: type,
      page: newPage,
      number_per_page: 8,
      sort: {
        publish_start_date: -1,
      },
    };

    let res = await await publicApi.getContentList(body);
    if (res) {
      if (res["data"]["code"] === 200) {
        setContent(res["data"]["content_list"]);
        setAmount(res["data"]["amount"]);
        setMaxPage(Math.ceil(res["data"]["amount"] / 8));
      } else if (res["data"]["code"] === 403) {
        navigate(RedirectCode400());
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  const convertToThaiDate = (dateString) => {
    const thaiMonths = [
      "ม.ค.",
      "ก.พ.",
      "มี.ค.",
      "เม.ย.",
      "พ.ค.",
      "มิ.ย.",
      "ก.ค.",
      "ส.ค.",
      "ก.ย.",
      "ต.ค.",
      "พ.ย.",
      "ธ.ค.",
    ];

    const date = new Date(dateString);
    const day = date.getDate();
    const month = thaiMonths[date.getMonth()];
    const year = (date.getFullYear() + 543) % 100;

    return `${day} ${month} ${year}`;
  };

  const extracThaiDate = (dateString) => {
    const date = new Date(dateString);
    const day = date.getDate();
    return `${day}`;
  };

  const extracThaiMonthYear = (dateString) => {
    const thaiMonths = [
      "ม.ค.",
      "ก.พ.",
      "มี.ค.",
      "เม.ย.",
      "พ.ค.",
      "มิ.ย.",
      "ก.ค.",
      "ส.ค.",
      "ก.ย.",
      "ต.ค.",
      "พ.ย.",
      "ธ.ค.",
    ];
    const date = new Date(dateString);
    const month = thaiMonths[date.getMonth()];
    const year = (date.getFullYear() + 543) % 100;
    return `${month} ${year}`;
  };

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  return (
    <>
      <div className="global-page">
        {/* {disabledMenu ? null : <HeadBar menu={"news"} />} */}
        <Breadcrumb pathItems={pathItems} />
        <PageHeader titlename={titleName} />

        {params.slug !== "announcement" && (
          <>
            <div className="sm:gap-4 md:!grid-cols-1 lg:grid-cols-2 grid grid-flow-dense grid-cols-4 gap-7">
              {content.map((content, index) => (
                <div
                  key={index}
                  className="flex flex-col justify-start items-center max-h-[500px] cursor-pointer"
                  onClick={() =>
                    navigate(`/${params.slug}/${content.content_id}`)
                  }
                >
                  <>
                    <div className="overflow-hidden w-full h-[270px] rounded-md cursor-pointer">
                      <img
                        alt="Content Thumbnail"
                        className={`h-full w-full border transition-transform dura tion-300 hover:scale-110 rounded-lg ${content.thumbnail ? "object-cover" : "object-contain"}`}
                        src={content.thumbnail ? content.thumbnail : logo__home}
                      />
                    </div>
                    <div className="flex flex-col items-center w-full pt-3">
                      {index === 0 && page === 1 && (
                        <div className="flex px-1 pt-3 w-full">
                          <div className="lg:text-[8px] lg:px-3 flex text-start px-4 py-1 text-[10px] text-white bg-red-500 rounded-[25px]">
                            New Update
                          </div>
                        </div>
                      )}
                      <span className="lg:text-xs px-1 py-3 w-full text-sm text-gray-500">
                        โพสต์เมื่อ{" "}
                        {convertToThaiDate(content.publish_start_date.date)}
                      </span>
                      <span
                        className={`xl:text-base px-1 w-full text-lg font-bold ${style.truncate}`}
                      >
                        {content.title}
                      </span>
                      <span
                        className="p-1 w-full text-sm underline cursor-pointer text-[#FF9768]"
                        onClick={() => navigate(`/news/${content.content_id}`)}
                      >
                        อ่านเพิ่มเติม
                      </span>
                    </div>
                  </>
                </div>
              ))}
            </div>
            <div className="flex w-full justify-center mt-[20px]">
              {amount > 0 ? (
                <Pagination
                  page={page}
                  totalpage={maxPage}
                  clickForward={() => {
                    if (page < maxPage) {
                      setPage(page + 1);
                    }
                  }}
                  clickBackward={() => {
                    if (page > 1) {
                      setPage(page - 1);
                    }
                  }}
                  choosePage={handlePageChange}
                  firstOrder={() => {
                    setPage(1);
                  }}
                  endOrder={() => {
                    setPage(maxPage);
                  }}
                />
              ) : (
                "ไม่มีข้อมูล"
              )}
            </div>
          </>
        )}

        {params.slug === "announcement" && (
          <>
            <div>
              <div className="flex flex-col w-full bg-gray-200 gap-[2px]">
                {content.map((announcement, index) => (
                  <div
                    key={index}
                    className="flex flex-row w-full justify-between items-start gap-4 py-4 bg-white cursor-pointer"
                    onClick={() =>
                      navigate(`/announcement/${announcement.content_id}`)
                    }
                  >
                    <div className="2sm:flex-col-reverse 2sm:items-center flex flex-row w-[10%] gap-1 justify-start items-start">
                      <div className="flex flex-col justify-center items-center">
                        <span className="xl:text-xl flex text-2xl text-red-500 font-bold">
                          {extracThaiDate(announcement.publish_start_date.date)}
                        </span>
                        <span className="xl:text-xs flex text-sm text-nowrap">
                          {extracThaiMonthYear(
                            announcement.publish_start_date.date,
                          )}
                        </span>
                      </div>
                      {index === 0 && (
                        <div className="lg:px-2 lg:py-[2px] lg:text-[8px] mt-2 px-4 py-1 bg-red-500 text-xs text-white text-center rounded-[25px]">
                          New
                        </div>
                      )}
                    </div>
                    <div className="xl:text-sm xl:px-5 pr-5 text-lg font-bold w-full text-start">
                      {announcement.title}
                    </div>
                    <a className="md:text-[11px] p-1 w-[10%] text-sm underline cursor-pointer text-end text-nowrap text-[#FF9768]">
                      อ่านเพิ่มเติม
                    </a>
                  </div>
                ))}
              </div>
            </div>
            <div className="flex justify-center mt-[20px]">
              {amount > 0 ? (
                <Pagination
                  page={page}
                  totalpage={maxPage}
                  clickForward={() => {
                    if (page < maxPage) {
                      setPage(page + 1);
                    }
                  }}
                  clickBackward={() => {
                    if (page > 1) {
                      setPage(page - 1);
                    }
                  }}
                  choosepage={handlePageChange}
                />
              ) : (
                "ไม่มีข้อมูล"
              )}
            </div>
          </>
        )}
      </div>
    </>
  );
}

export default Content;
